import React from "react";
import { Fade } from "react-awesome-reveal";
import { useMediaQuery } from "react-responsive";
import "../styles/PorqueElegirnos.scss";
import id1 from "../images/identificadores/1.svg";
import id2 from "../images/identificadores/2.svg";
import id3 from "../images/identificadores/3.svg";
import id4 from "../images/identificadores/4.svg";
import id5 from "../images/identificadores/5.svg";

const PorqueElegirnos = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  let velFade = 2000;

  const tarjetas = [
    {
        id: 1,
        imagen: id1,
        titulo: 'Formación Integral',
        texto: 'Recibe capacitación continua en seguros, finanzas, ventas y desarrollo personal. Te preparamos paso a paso para convertirte en un asesor exitoso con bases sólidas y propósito.',
    },
    {
        id: 2,
        imagen: id2,
        titulo: 'Acompañamiento y Mentoría',
        texto: 'No caminas solo. Tendrás el apoyo de mentores y líderes con experiencia que te guiarán en cada etapa de tu crecimiento profesional y financiero.',
    },
    {
        id: 3,
        imagen: id3,
        titulo: 'Ingresos Sin Límite',
        texto: 'Tu esfuerzo define tus resultados. Obtén comisiones, bonos y reconocimientos por tu desempeño. Aquí tú construyes tu propio éxito.',
    },
    {
        id: 4,
        imagen: id4,
        titulo: 'Comunidad y Crecimiento',
        texto: 'Forma parte de una comunidad de agentes con visión, empatía y pasión por ayudar a las familias mexicanas. Crecemos juntos, compartiendo experiencias y logros.',
    },
    {
        id: 5,
        imagen: id5,
        titulo: 'Propósito y Trascendencia',
        texto: 'Más que vender seguros, ayudamos a proteger sueños y futuros. En Asesorarte en Seguros encontrarás una carrera que transforma vidas, empezando por la tuya.',
    },
  ];

  return (
    <section className="bg-body-tertiary text-center" id="porqueE">
    <br/>
      <center>
        <Fade>
          <br/><h4 className="fw-bold fs-3 firstText" id="titlePorque">
            ¿Por qué elegirnos?
          </h4>
        </Fade>
      </center>
      <div className="containerCards">
            {tarjetas.map((tarjeta) => (
                <div key={tarjeta.id} className="containerCard text-center">
                    {isMobile && (
                        <Fade duration={velFade}>
                            <img className="imgCard" src={tarjeta.imagen} alt={tarjeta.titulo} />
                            <div className="containerCardText">
                                <p className="firstText fw-bold">{tarjeta.titulo}</p>
                                <p className="textIdentificador">{tarjeta.texto}</p>
                            </div>
                        </Fade>
                    )}
                    {!isMobile && (
                        <div>
                            <img className="imgCard" src={tarjeta.imagen} alt={tarjeta.titulo} />
                            <div className="containerCardText">
                                <p className="firstText fw-bold">{tarjeta.titulo}</p>
                                <p className="textIdentificador">{tarjeta.texto}</p>
                            </div>
                        </div>
                    )}
                </div>
            ))}
      </div>
      <br/><br/><br/>
    </section>
  );
};

export default PorqueElegirnos;
